/**
 * Button size and shape constants.
 * Combine with a theme color key:
 *
 *   <button className={`${btn.base} ${btn.md} ${theme.buttonPrimary}`}>Save</button>
 *   <button className={`${btn.base} ${btn.sm} ${theme.buttonDanger}`}>Delete</button>
 *   <button className={`${btn.base} ${btn.md} ${theme.buttonGhost}`}>Cancel</button>
 */
export const btn = {
  base: 'rounded-lg font-medium transition-colors disabled:opacity-50 disabled:cursor-not-allowed',
  sm:   'px-3 py-1.5 text-xs',
  md:   'px-4 py-2 text-sm',
  lg:   'px-6 py-3 text-base',
  // Icon-only buttons
  icon:   'p-2 rounded-lg transition-colors',
  iconSm: 'p-1.5 rounded-lg transition-colors',
  // Button group containers — consistent spacing between sibling buttons
  group:   'flex items-center gap-3',
  groupSm: 'flex items-center gap-2',
};
